const { gql, request } = require('graphql-request');
const { _add0x } = require('./utils');
const { _getChainSpecificConstants, _extractChainID, customErrors } = require('./constants.js');

const _getAllIndexesOwnedByAUser = async (signer, userAddress) => {

	const chainID = await _extractChainID(signer);
	const { stakehouseUrls } = _getChainSpecificConstants(chainID);

    const lookupQuery = gql`
		query getAllIndexes($account: String!) {
			savETHIndexes (where: {indexOwner: $account}
                orderBy: indexId orderDirection: asc
				first: 1000
            ) {
                id
            }
        }
	`;

    const response = await request(
		stakehouseUrls.SUBGRAPH_ENDPOINTS,
		lookupQuery,
		{
			account: userAddress
		}
	);

    if (!response || !response.savETHIndexes) {
		throw new Error('Invalid response getting indexes owned by the KNOT');
	}

    return response.savETHIndexes;
};

const _getPersonalIndex = async (signer, userAddress) => {

    const listOfIndex = await _getAllIndexesOwnedByAUser(signer, userAddress);

    if(listOfIndex.length < 1) {
        throw customErrors.INDEX_LENGTH_ZERO;
    }

    return listOfIndex[0];
};

const _knotToStakehouse = async (signer, id) => {

	const chainID = await _extractChainID(signer);
	const { stakehouseUrls } = _getChainSpecificConstants(chainID);

	const lookupQuery = gql`
		query getKnotStakehouse($id: ID!) {
			knot (id: $id){
                stakeHouse
            }
		}
	`;
  
	const response = await request(
		stakehouseUrls.SUBGRAPH_ENDPOINTS,
		lookupQuery,
		{
			id: _add0x(id.toLowerCase())
		}
	);
  
	if (!response || !response.knot) {
		throw new Error('Invalid response getting the Stakehouse of the KNOT')
	}
    
    return response.knot.stakeHouse
};

const _getAllEventsForAKnot = async (signer, blsPublicKey) => {

	const chainID = await _extractChainID(signer);
	const { stakehouseUrls } = _getChainSpecificConstants(chainID);

	const lookupQuery = gql`
		query getAllEvents($blsPublicKey: String!){
			events(where: { blsPubKeyForKnot: $blsPublicKey },
				orderBy: blockNumber, orderDirection: desc
				first: 1000
			) {
				key
				value
				blockNumber
			}
		}
	`;

	const response = await request(
		stakehouseUrls.SUBGRAPH_ENDPOINTS,
		lookupQuery,
		{
			blsPublicKey: _add0x(blsPublicKey.toLowerCase())
		}
	);
  
	if (!response || !response.events) {
		throw new Error('Invalid response getting the events for the KNOT')
	}

	return response.events
}

module.exports = {
    _getAllIndexesOwnedByAUser,
    _getPersonalIndex,
    _knotToStakehouse,
	_getAllEventsForAKnot
};
